import { IContactSettingWithIcon } from '../model/utils'

export const contactStatus: Array<IContactSettingWithIcon> = [
  {
    id: 'no-contact',
    class: 'hpicon hpicon-mindset-none',
    color: '#A4A4A4',
    hint: 'No Contact',
    isDefault: true,
  },
  {
    id: 'negative-contact',
    class: 'hpicon hpicon-mindset-negative',
    color: '#BE3754',
    hint: 'Negative Contact',
    isDefault: false,
  },
  {
    id: 'mild-contact',
    class: 'hpicon hpicon-mindset-mild',
    color: '#E8813D',
    hint: 'Mild Contact',
    isDefault: false,
  },
  {
    id: 'strong-contact',
    class: 'hpicon hpicon-mindset-strong',
    color: '#08B158',
    hint: 'Strong Contact',
    isDefault: false,
  },
]

export const contactChangeMindset: Array<IContactSettingWithIcon> = [
  {
    id: 'progress-100',
    class: 'hpicon hpicon-progress-100',
    color: '#0E93D2',
    hint: '100%',
    isDefault: false,
  },
  {
    id: 'progress-75',
    class: 'hpicon hpicon-progress-75',
    color: '#0E93D2',
    hint: '75%',
    isDefault: false,
  },
  {
    id: 'progress-50',
    class: 'hpicon hpicon-progress-50',
    color: '#0E93D2',
    hint: '50%',
    isDefault: false,
  },
  {
    id: 'progress-25',
    class: 'hpicon hpicon-progress-25',
    color: '#0E93D2',
    hint: '25%',
    isDefault: false,
  },
  {
    id: 'progress-0',
    class: 'hpicon hpicon-progress-0',
    color: '#0E93D2',
    hint: '0%',
    isDefault: true,
  },
]

export const contactRoles: Array<IContactSettingWithIcon> = [
  {
    id: 'loyality-star',
    class: 'hpicon hpicon-loyality-star',
    color: '#E88846',
    hint: 'Decision Maker',
    isDefault: false,
  },
  {
    id: 'loyality-co',
    class: 'hpicon hpicon-loyality-co',
    color: '#E88846',
    hint: 'Coach',
    isDefault: false,
  },
  {
    id: 'loyality-gk',
    class: 'hpicon hpicon-loyality-gk',
    color: '#E88846',
    hint: 'Gate Keeper',
    isDefault: false,
  },
  {
    id: 'loyality-in',
    class: 'hpicon hpicon-loyality-in',
    color: '#E88846',
    hint: 'Influencer',
    isDefault: false,
  },
  {
    id: 'loyality-ad',
    class: 'hpicon hpicon-loyality-ad',
    color: '#E88846',
    hint: 'Advisor',
    isDefault: false,
  },
]

export const contactRelationship: Array<IContactSettingWithIcon> = [
  {
    id: '-2',
    class: 'hpicon hpicon-levels-2-1',
    color: '#EA4D6B',
    hint: '-2',
    isDefault: false,
  },
  {
    id: '-1',
    class: 'hpicon hpicon-levels-1-1',
    color: '#EA4D6B',
    hint: '-1',
    isDefault: false,
  },
  {
    id: '0',
    class: 'hpicon hpicon-levels-0',
    color: '#999999',
    hint: '0',
    isDefault: true,
  },
  {
    id: '1',
    class: 'hpicon hpicon-levels-1',
    color: '#05753B',
    hint: '1',
    isDefault: false,
  },
  {
    id: '2',
    class: 'hpicon hpicon-levels-2',
    color: '#05753B',
    hint: '2',
    isDefault: false,
  },
]
